import { SvgStar } from "icons/SvgStar"
import { useEffect, useState } from "react"


export const StatisticsDays = ({ accountData, statics, metrics }: any) => {
    let [data, setData] = useState({
        'days': 0,
        'percent': 0,
    })

    useEffect(() => {
        if (statics?.licence) {
            let obj:any = {
                'days': accountData?.challenge_type == 'trade_competitions' ? 7 : statics?.licence?.remaining_days_of_challenge,
            }
            // if(accountData?.level == 3){
            //     obj['percent'] = 100 ;
            // }
             if (accountData?.challenge_type == 'trade_competitions'){
                obj['percent'] = 7 ;
            }
            else {
                obj['percent'] = (statics?.licence?.remaining_days_of_challenge * 100) / statics?.licence?.count_of_licence_days ;
            }
            setData(obj)
        }
    }, [statics])

    return (
        <>
            <div className="md:w-[70%] w-full md:pl-2 pl-0">
                <div className="w-full min-h-[86px] p-2 rounded-md bg-trade-50 flex md:flex-row flex-col items-center justify-between">
                    <div className="w-[130px] h-[70px] ml-2 relative text-white border border-gray-500 rounded-lg flex flex-col items-center justify-center  order-1">
                        <span className="text-[10px]">حداقل روزهای ترید 5 روز</span>
                        <SvgStar className={` w-[35px] mt-2 ${metrics?.['_trade_days_count'] > 5 ? 'fill-green-600' : 'fill-[tomato]'}  `} />
                        <span className="text-white text-sm absolute mt-[28px]">{metrics?.['_trade_days_count']}</span>
                    </div>
                    <div className=" md:w-[65%] w-[90%] flex items-center md:mt-0 mt-7 md:mb-0 mb-2 md:order-2 order-3">
                        <div className="w-full flex flex-col relative">
    
                                <span className="absolute text-xs text-white -top-6 " style={{ right: data.percent > 95 ? '90%' : `${data.percent}%` }}>{data.days} روز</span>
                            
                            <div className="w-full h-[10px] rounded-full bg-trade-25 flex">
                                <div className="transition-all duration-700 bg-[#2563eb] h-[10px] shadow rounded-full" style={{ width: `${data.percent}%` }}></div>
                            </div>
                        </div>
                    </div>
                    <span className="w-[100px] text-sm mr-3 text-white md:order-3 order-2 md:mt-0 mt-2">مانده از تاریخ</span>
                </div>
            </div>
        </>
    )
}